pageId = 'reports-questions-edit'

$(document).on "pjaxload##{ pageId }", (e, $page, page) ->
  tower.initReportQuestionForm()
  tower.reportsQuestionsLogs()
